//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import PosCashDeskListView from '@/views/POS/PosCashDesk/list'
import PosCashDeskCreateView from '@/views/POS/PosCashDesk/create'
import PosCashDeskUpdateView from '@/views/POS/PosCashDesk/update'

//
export default {
  path: 'pos_cash_desk',
  component: ModuleLayout,
  children: [
    {
      name: 'pos-cash-desk-list',
      path: '',
      component: PosCashDeskListView,
    },
    {
      name: 'pos-cash-desk-create',
      path: 'create',
      component: PosCashDeskCreateView,
      meta: {
        title: 'Crear caja'
      },
    },
    {
      name: 'pos-cash-desk-update',
      path: ':id',
      component: PosCashDeskUpdateView,
      meta: {
        title: 'Datos de caja'
      },
    },
  ],
  meta: {
    title: 'Cajas'
  },
}